module.exports = __webpack_public_path__ + "static/media/healthcare.387e8f0f.png";